module.exports = __webpack_public_path__ + "img/img-top.b0731f75.png";